import { render, staticRenderFns } from "./DatasetDetails.vue?vue&type=template&id=f2aaf686&scoped=true&"
var script = {}
import style0 from "./DatasetDetails.vue?vue&type=style&index=0&id=f2aaf686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2aaf686",
  null
  
)

export default component.exports